<template>
  <!-- <div id="botaoVoltarTopo" @scroll="scrolle" class="botao-rolagem">
    <button class="voltar-ao-topo" @click="voltarAoTopo">&#8249;</button>
  </div>-->
  <div class="botao-rolagem" @scroll="handleScroll">
    <button
      :class="scrolled === false ? 'voltar-ao-topo escondido' : 'voltar-ao-topo'"
      @click="voltarAoTopo"
    >
      <img src="@/assets/imgs/icone_topo_branco.png" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'BotaoVoltarTopo',
  data() {
    return {
      visivel: false,
      janela: window.pageYOffset,
      scrolled: false,
    };
  },
  methods: {
    voltarAoTopo() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    scrolle() {
      if (window.pageYOffset > 200) {
        return (this.visivel = true);
      }
      return (this.visivel = false);
    },

    rolagem() {
      this.scrolled = window.scrollY > 200;
    },

    handleScroll() {
      this.scrolled = window.scrollY > 0;
    },
  },

  created() {
    window.addEventListener('scroll', this.handleScroll);
    document.body.addEventListener('scroll', this.rolagem);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.removeEventListener('scroll', this.rolagem);
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.botao-rolagem {
  > button {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
  & .voltar-ao-topo {
    display: flex;
    flex-direction: center;
    justify-content: center;
    @extend %nao-selecionavel;
    font-family: 'OpenSans';
    background-color: #f0f0f0;
    font-size: 24px;
    width: 40px;
    height: 40px;
    line-height: 0px;
    border-radius: 22px;
    border: 0px;
    position: fixed;
    bottom: 40px;
    right: 20px;
    text-align: center;
    outline: none;
    transition: all 0.2s linear;
    cursor: pointer;
    z-index: 99;
    padding: 0px;
    padding-bottom: 0px !important;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);

    & img {
      align-self: center;
      width: 16px;
      height: 16px;
      filter: grayscale(1) brightness(0.3);
    }

    &:hover {
      transform: scale(1.2);
    }
    &:focus {
      animation: grow 0.25s linear;
    }
  }

  & .escondido {
    bottom: -40px;
  }
}
@keyframes grow {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .botao-rolagem {
    & .voltar-ao-topo {
      font-size: 15px;
      width: 40px;
      height: 40px;
      bottom: 20px;
      right: 10px;
      padding-bottom: 0;

      &:hover {
        transform: none;
      }
    }
    & .escondido {
      bottom: -10vmax;
    }
  }
}
</style>
